import { useSearchParams } from "react-router";
import { PageTracker } from "@/components/analytics/page-tracker";
import { AuthForm } from "@/components/auth/auth-form";
import { usePageTitle } from "@shared/client/view";
import { EVENTS } from "@shared/lib/analytics";
import { parseSiteUrl } from "@shared/lib/url";
import { useT } from "@shared/client/locale";

export default function SignupPage() {
  usePageTitle(useT().auth.pageTitles.signup);
  const [params] = useSearchParams();
  return (
    <>
      <PageTracker event={EVENTS.SIGNUP_VIEWED} />
      <AuthForm
        mode="signup"
        initialError={params.get("error") || ""}
        site={parseSiteUrl(params.get("site") ?? "") ?? undefined}
      />
    </>
  );
}
